import Component from './InDmChatArea.vue'
export default Component
export * from './types'
